import { command } from '$app/server';
import { requireUser } from '#lib/server/auth/requireUser.js';
import { recordClientError } from '#lib/server/clientErrors/clientErrorLog.js';
import { ClientErrorReportSchema } from './clientErrorReport';

/**
 * A crash in the browser leaves no trace on the server: the page swaps in its
 * error screen and the logs stay clean. The client hook hands each unexpected
 * error here, and it is kept in `<volume>/logs/client-errors.jsonl`, which
 * outlives the container's own log.
 */
export const reportClientError = command(ClientErrorReportSchema, async (report) => {
	const user = requireUser();
	console.error({ kind: 'client', user: user.email, ...report });
	await recordClientError(user.email, report);
});
